module.exports = __webpack_public_path__ + "img/empty-rg.807e931d.png";